module.exports = new __parcel__URL__("Mageskill_42.4595e76b.png").toString();